import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ClienteService } from '../../services/cliente.service';
import swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as dataDeptos from '../../localDataJson/departamentos.json';
import * as dataMuni from '../../localDataJson/municipios.json';
import * as moment from 'moment';
import {CommonFunctions} from '../../utils/common-functions';
import {NgxPermissionsService} from 'ngx-permissions';
import { AlertService } from '../../services/alert.service';
import { Constants } from '../../utils/constants';
import { ModalOtpComponent } from "../../components/modal-otp/modal-otp.component";
import {
  MatDialog
} from "@angular/material/dialog";
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-gestiones-datosgenerales-precalificacion',
  templateUrl: './gestiones-datosgenerales-precalificacion.component.html',
  styleUrls: ['./gestiones-datosgenerales-precalificacion.component.scss']
})
export class GestionesDatosgeneralesPrecalificacionComponent implements OnInit, OnDestroy {
  // ngx-ui-loader indexa las tareas por taskId: el loader solo se oculta cuando no
  // queda ninguna tarea viva en el loaderId. Si todas las operaciones comparten un
  // mismo taskId, un stop apaga el spinner de otra operación aún en curso y un start
  // posterior lo revive, por lo que cada operación asíncrona usa aquí su propio id.
  private readonly LOADER_ID = 'loader-global';
  private readonly TASK_PRODUCTOS = 'dgp-consulta-productos';
  private readonly TASK_NIT = 'dgp-consulta-nit';
  private readonly TASK_OTP = 'dgp-solicitud-otp';
  private readonly TASK_CODEUDOR = 'dgp-rechazo-codeudor';
  private readonly TASK_OFERTA = 'dgp-solicitar-oferta';
  @Input() clienteserviceParam: ClienteService;
  @Output() selecttab = new EventEmitter<number>();
  @Output() refreshPrecalificaciones = new EventEmitter<boolean>();
  @Output() setDataCliente = new EventEmitter<any>();
  departamentos: any = (dataDeptos as any).default;
  municipios: any = (dataMuni as any).default;
  municipiosAux; //Arreglo auxiliar para filtro por departamento
  public mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  direccionPrincipal = {
    correlativoDireccion: '',
    departamento: '',
    direccionRegistrada: '',
    esDireccionPrincipal: '',
    municipio: '',
    tipoDireccionRegistrada: '',
    zona: ''
  };
  telefonoPrincipal;
  movilPrincipal;
  edadCliente;
  estadoCivil = '';
  estadoCivilOptions = [
    { value: 'C', label: 'CASADO' },
    { value: 'D', label: 'DIVORCIADO' },
    { value: 'S', label: 'SOLTERO' },
    { value: 'V', label: 'VIUDO' }
  ];
  tipoVivienda = '';
  tipoViviendaOptions = [
    { value: '1', label: 'ALQUILADA' },
    { value: '2', label: 'PROPIA' },
    { value: '3', label: 'FAMILIAR' },
    { value: '4', label: 'PARCIALMENTE PAGADA' },
    { value: '5', label: 'EN USUFRUCTO' },
    { value: '88', label: 'DEPURA. BENEFIC.' }
  ];
  patronoSelected: any = {};
  isNitRequest = false;
  clientData: any = {};
  age = 0;
  errorSatFlag=false
  codDeptoFilter=''
  constructor(
    private ngxUiLoaderService: NgxUiLoaderService,
    private ngxPermissionService: NgxPermissionsService,
    private alertService: AlertService,
    public dialog: MatDialog,
    private authService: AuthService
    ) {
    setTimeout(() => {
      this.errorSatFlag=this.clientData.cliente.errorSatFlag //se valida si no se obtuvo información de la sat para clientes nuevos
      if (this.clientData.cliente.existeClienteActivoBanca === 'S') {
        this.setData();
      }
      if (this.clienteserviceParam.datosPrecalificacion.alertainicial == null && this.clienteserviceParam.consultaFlag==false &&this.clienteserviceParam.rolABFlag==false) {
        this.showNotification('Importante', 'Te recordamos consultar el Manual de Créditos vigente publicado en Docuware.');
        this.clienteserviceParam.datosPrecalificacion.alertainicial = true;
      }
      this.getEdadCliente();
    }, 500);

  }
  datosAvalidar = {
    casadaApellido: true,
    dpi: true,
    email: true,
    estadoCivil: true,
    fechaEmisionDPI: true,
    fechaNacimiento: true,
    genero: true,
    nit: true,
    primerApellido: true,
    primerNombre: true,
    segundoApellido: true,
    segundoNombre: true,
    tipoVivienda:true,
  };

  ngOnInit(): void {
    this.clientData =  this.clienteserviceParam.flowType === 'DEBTOR'
    ? this.clienteserviceParam.datosCliente : this.clienteserviceParam.datosCodeudor;

    if (this.clientData && this.clientData.cliente && this.clientData.cliente.estadoCivil) {
      this.estadoCivil = this.estadoCivilOptions.find(option => option.value === this.clientData.cliente.estadoCivil)?.label;
    }
   
    this.movilPrincipal = this.clienteserviceParam.flowType === 'DEBTOR'
    ? (this.clienteserviceParam.datosPrecalificacion?.celular
        ?? this.clienteserviceParam.datosCliente?.cliente?.telefono
        ?? '')
    : (this.clienteserviceParam.datosPrecalificacionCodeudor?.celular
        ?? this.clienteserviceParam.datosCodeudor?.cliente?.telefono
        ?? '');
    
    if (!this.movilPrincipal) {
      this.movilPrincipal = this.clientData?.cliente?.telefono
        ?? this.clienteserviceParam.datosPrecalificacion?.celular
        ?? '';
    }
    if (this.clientData && this.clientData.cliente && this.clientData.cliente.tipoVivienda) {
      this.tipoVivienda = this.tipoViviendaOptions.find(option => option.value === this.clientData.cliente.tipoVivienda)?.label;
    }
    
    for (const  i in  this.datosAvalidar) {
      for (const  j in  this.clientData.cliente) {
        if (i === j) {
          if (this.clientData.cliente[j] == null || this.clientData.cliente[j] === '') {
            this.datosAvalidar[i] = false;
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    // El componente se destruye al cambiar de tab (*ngIf="tabselected==14"). Si alguna
    // de sus tareas siguiera viva, nadie podría apagarla y el spinner quedaría girando.
    [
      this.TASK_PRODUCTOS,
      this.TASK_NIT,
      this.TASK_OTP,
      this.TASK_CODEUDOR,
      this.TASK_OFERTA
    ].forEach(taskId => this.stopTask(taskId));
  }

  private startTask(taskId: string): void {
    this.ngxUiLoaderService.startLoader(this.LOADER_ID, taskId);
  }

  private stopTask(taskId: string): void {
    this.ngxUiLoaderService.stopLoader(this.LOADER_ID, taskId);
  }

  goToIngresos() {
    if (this.clienteserviceParam.consultaFlag) {
      this.selecttab.emit(16)
    } else {
      this.clientData.cliente.telefono = this.movilPrincipal;

      if (this.clienteserviceParam.flowType === 'DEBTOR') {
        this.clienteserviceParam.datosPrecalificacion.celular = this.movilPrincipal;
      } 
      else 
      {
        this.clienteserviceParam.datosPrecalificacionCodeudor.celular = this.movilPrincipal;
      }
          
      const birthdate = moment(this.clientData.cliente.fechaNacimiento, 'DD/MM/YYYY', true);
      if (this.clientData.cliente.existeClienteActivoBanca === 'N'
        && this.clientData.cliente.tipoClasificacionCliente === 'CN') {
        if(!this.clienteserviceParam.rolABFlag){
          this.clientData.cliente.email = '';
        }
  
        if (this.clientData.cliente.dpi == null) {
          this.showNotification('Alerta', 'Debe ingresar un DPI.');
        } else if (this.clientData.cliente.primerNombre == null || this.clientData.cliente.primerNombre =='') {
          this.showNotification('Alerta', 'Debe ingresar el Primer Nombre.');
        } else if (this.clientData.cliente.primerApellido == null || this.clientData.cliente.primerApellido=='') {
          this.showNotification('Alerta', 'Debe ingresar el Primer Apellido.');
        }
        else if (this.clientData.cliente.nit == null) {
          this.showNotification('Alerta', 'Debe ingresar un NIT.');
        } else if (this.clientData.cliente.genero == null) {
          this.showNotification('Alerta', 'Debe ingresar el género');
        } else if (this.clientData.cliente.estadoCivil == null) {
          this.showNotification('Alerta', 'Debe ingresar el Estado Civil');
        }  else if (this.clientData.cliente.email == null || this.clientData.cliente.email === '') {
          this.showNotification('Alerta', 'Debe ingresar un correo electrónico.');
        } else if (!this.validarEmail(this.clientData.cliente.email)) {
          this.showNotification('Alerta', 'Debe ingresar un correo electrónico válido.');
        } else if (this.clientData.cliente.tipoVivienda == null || this.clientData.cliente.tipoVivienda === '') {
          this.showNotification('Alerta', 'Debe ingresar el Tipo de Vivienda');
        } 
        // else if (this.telefonoPrincipal && this.telefonoPrincipal !== ''
        //   && (this.validarTelefono(this.telefonoPrincipal) === 'cel'
        //     || this.validarTelefono(this.telefonoPrincipal) === 'invalido')) {
        //   this.showNotification('Alerta', 'Debe ingresar un número de teléfono de casa válido');
        else if (this.movilPrincipal == null || this.movilPrincipal=='') {
           this.showNotification('Alerta', 'Debe ingresar un número de celular');
        } else if (this.validarTelefono(this.movilPrincipal) === 'invalido'
           || this.validarTelefono(this.movilPrincipal) === 'tel') {
           this.showNotification('Alerta', 'Debe ingresar un número de celular válido');
        } 
        else if (!birthdate.isValid()) {
          this.showNotification('Alerta', 'Debe ingresar una fecha de nacimiento correcta');
        } else if (this.age === 0) {
          this.showNotification('Alerta', 'Debe ingresar una fecha de nacimiento correcta');
        } else if (this.clientData.cliente.fechaNacimiento ==null||this.clientData.cliente.fechaNacimiento === '') {
          this.showNotification('Alerta', 'Debe ingresar una fecha de nacimiento');
        } else {
          if (this.clienteserviceParam.flowType === 'DEBTOR') {
            this.clienteserviceParam.datosCliente = this.clientData;
          } else {
            this.clienteserviceParam.datosCodeudor = this.clientData;
          }
          if (this.errorSatFlag) {
            this.clientData.cliente.nombreCompleto = this.clientData.cliente.primerNombre + " " + this.clientData.cliente.primerApellido
          }
          this.showSegmentoSelect();
        }
      } else {
        if(!this.clienteserviceParam.rolABFlag){
          this.clientData.cliente.email = '';
        }
        if (this.movilPrincipal == null || this.movilPrincipal=='') {
          this.showNotification('Alerta', 'Debe ingresar un número de celular');
        } else if (this.validarTelefono(this.movilPrincipal) === 'invalido'
          || this.validarTelefono(this.movilPrincipal) === 'tel') {
          this.showNotification('Alerta', 'Debe ingresar un número de celular válido');
        } else if (this.telefonoPrincipal && this.telefonoPrincipal !== ''
          && (this.validarTelefono(this.telefonoPrincipal) === 'cel'
          || this.validarTelefono(this.telefonoPrincipal) === 'invalido')) {
          this.showNotification('Alerta', 'Debe ingresar un número de teléfono de casa válido');
        }  else if (this.clientData.cliente.fechaNacimiento === '') {
          this.showNotification('Alerta', 'Debe ingresar una fecha de nacimiento');
        } else if (this.clientData.cliente.nit === '') {
          this.showNotification('Alerta', 'Debe ingresar un NIT.');
        } else if (this.clientData.cliente.email == null || this.clientData.cliente.email === '') {
          this.showNotification('Alerta', 'Debe ingresar un correo electrónico.');
        } else if (!this.validarEmail(this.clientData.cliente.email)) {
          this.showNotification('Alerta', 'Debe ingresar un correo electrónico válido.');
        } else if (this.clientData.cliente.tipoVivienda == null || this.clientData.cliente.tipoVivienda === '') {
          this.showNotification('Alerta', 'Debe ingresar el Tipo de Vivienda');
        } else if (!birthdate.isValid()) {
          this.showNotification('Alerta', 'Debe ingresar una fecha de nacimiento correcta');
        } else if (this.age === 0) {
          this.showNotification('Alerta', 'Debe ingresar una fecha de nacimiento correcta');
        } else {
          if (this.isNitRequest === true) {
            this.satNitValidate();
          } else {
            if (this.clienteserviceParam.flowType === 'DEBTOR') {
              this.clienteserviceParam.datosCliente = this.clientData;
            } else {
              this.clienteserviceParam.datosCodeudor = this.clientData;
            }
            this.showSegmentoSelect();
          }
        }
      } 
    }
  }

  validarEmail(email: string): boolean {
    const re =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
  goBack() {
    this.refreshPrecalificaciones.emit(true);
    this.selecttab.emit(0);
  }
  getEdadCliente() {
    const fechaIngresada = moment(this.clientData.cliente.fechaNacimiento, 'DD/MM/YYYY').locale('es');
    const fechaactual = moment().locale('es');
    this.age = isNaN(fechaactual.diff(fechaIngresada, 'years'))
      ? 0 : fechaactual.diff(fechaIngresada, 'years');
  }

  showSegmentoSelect() {
    const publicStatePermission = this.ngxPermissionService.getPermission('evaluacionTipoEstado');
    const privateStatePermission = this.ngxPermissionService.getPermission('evaluacionTipoPrivada');
    const PagoVoluntarioStatePermission = this.ngxPermissionService.getPermission('evaluacionTipoPagoVoluntario');

    const optionsElements = [];
    let inputFuenteIngreso = '<select id="select2" class="swal2-select selectswal"><option value="" >Seleccione fuente de Ingreso</option><option value="1">Asalariado</option><option value="2">Independiente</option><option value="3">Servicios Profesionales</option></select>'
    if (PagoVoluntarioStatePermission) {
      optionsElements.push({value: "PV", text:"Pago Voluntario"})
    }
   
    if (publicStatePermission && this.clienteserviceParam.tipoPrecalificacion == 'credito_fiduciario') {
      optionsElements.push({value: "E", text:"Estado"})
    }
    if (publicStatePermission && this.clienteserviceParam.tipoPrecalificacion == 'tarjeta_credito') {
      optionsElements.push({value: "E", text:"Estado"})
    }

    if (privateStatePermission) {
      optionsElements.push({value: "P", text:"Privado"})
    }

    let firstInput = ""
    let segmentoSelected = "";
    let pagoVoluntarioSelected = "";
    let tipoPructoSelected="";
    optionsElements.forEach(element => {
      firstInput +="<option class='swal-input1' value="+element.value+">"+element.text+"</option>"
    });

    swal.fire({
      title: 'Segmento',
      html:'<select id="select1" class="swal2-select selectswal"><option value="" disabled="" selected="">Seleccione un segmento</option> '+firstInput+'</select>' +inputFuenteIngreso,
      inputPlaceholder: 'Seleccione un segmento',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'selectswal',
        title: 'titleswt',
      },
      didOpen: () => {
        localStorage.setItem("iniciaPreca", "ok");
      },
      willOpen: () => {
        const select1 = document.getElementById('select1');
        const select2 = document.getElementById('select2');
        select2.style.display = 'none';
        select1.addEventListener('change', function handleChange(event: Event): void {
          const target = event.target as HTMLSelectElement;
          if(!localStorage.getItem("codeudor")) {
            localStorage.setItem("moduleSubtitle", "");
            localStorage.setItem("moduleTitle", target.selectedOptions[0].innerHTML);
          }
          segmentoSelected = target.selectedOptions[0].innerHTML.slice(0, 2).toUpperCase();
          select2.style.display = 'none';
          if (segmentoSelected === "PA") {
            select2.style.display = 'block'
          }

          swal.resetValidationMessage();
        });

        select2.addEventListener('change', function handleChange(event: Event): void {
          const target = event.target as HTMLSelectElement;
          if(!localStorage.getItem("codeudor")) {
            localStorage.setItem("moduleSubtitle", target.selectedOptions[0].innerHTML);
          }
          pagoVoluntarioSelected = target.selectedOptions[0].innerHTML.slice(0, 2).toUpperCase();
          swal.resetValidationMessage();
        });
      },
      didClose: () => {

      },
      inputValidator: result => !result && 'Por favor seleccione un segmento.',
      showCloseButton: true,
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      heightAuto: false,
      confirmButtonText: 'Continuar',
      preConfirm: (value) => {
        return [
          segmentoSelected, 
          pagoVoluntarioSelected
        ]
      },
    }).then(result => {

      if (!result.isConfirmed) {
        localStorage.setItem("iniciaPreca", "");
        localStorage.setItem("moduleTitle", "");
        localStorage.setItem("moduleSubtitle", "");
        localStorage.setItem("codeudor", "");
      }

      if (result.isConfirmed) {
        if(result?.value[0] == "") {
          this.showSegmentoSelect();
          swal.showValidationMessage("Por favor seleccione un segmento");	
          return false;
        }

        if(result?.value[0] == "PA" && result?.value[1] =="") {
          this.showSegmentoSelect();
          swal.showValidationMessage("Por favor seleccione una fuente de ingreso");	
          return false;
        }

        let segmento = null;
        let segmentoPV = " "

        if(result?.value[0] == "PA") {
          segmento = "PV"
          segmentoPV = result?.value[1].slice(0, 1);
        } else {
          segmento = result?.value[0].slice(0, 1);
          segmento=segmento=='R'?'E':segmento
        }

        if (segmento === 'E') {
          this.clientData.cliente.existeEmpleadoGobierno = 'S';
        }
        if (this.clienteserviceParam.flowType === 'DEBTOR') {
          this.clienteserviceParam.datosPrecalificacion.segmento = segmento;
          this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario = segmentoPV;
          this.clienteserviceParam.datosPrecalificacion.direccion = this.direccionPrincipal;
          this.clienteserviceParam.datosPrecalificacion.telefono = this.telefonoPrincipal;
          this.clienteserviceParam.datosPrecalificacion.celular = this.movilPrincipal;
        } else {
          this.clienteserviceParam.datosPrecalificacionCodeudor.segmento = segmento;
          this.clienteserviceParam.datosPrecalificacionCodeudor.codigoSegmentoRiesgoPagoVoluntario = segmentoPV;
          this.clienteserviceParam.datosPrecalificacionCodeudor.direccion = this.direccionPrincipal;
          this.clienteserviceParam.datosPrecalificacionCodeudor.telefono = this.telefonoPrincipal;
          this.clienteserviceParam.datosPrecalificacionCodeudor.celular = this.movilPrincipal;
        }
        if (this.clientData.cliente.existeClienteActivoBanca === 'N'
          && this.clientData.cliente.tipoClasificacionCliente === 'CN') {
          this.startTask(this.TASK_PRODUCTOS);
          this.clienteserviceParam.ConsultaProducoCliente(this.clientData.cliente).then(dataproductos => {
            this.stopTask(this.TASK_PRODUCTOS);
            if (this.clienteserviceParam.flowType === 'DEBTOR') {
              this.validateSIRC(dataproductos);
            } else {
              const response = CommonFunctions.validateIndirectCreditsCoDebtor(
                this.clienteserviceParam.productosCliente.internoBantrab,
                this.clienteserviceParam.productosCodeudor.internoBantrab,
                this.clienteserviceParam.datosPorductosClientes,
              );
              if (response.canCoDebtor === true) {
                if (response.commonCredits.length > 0) {
                  this.alertService.confirmationHMTL(
                    `<strong>Nota:</strong>`,
                    `<span>Se detecto que el codeudor comparte un producto en común con el deudor, el cual se tendrá que consolidar al finalizar el registro del mismo ¿Desea continuar con el codeudor?</span><br>`,
                    'Continuar'
                  ).then(confirm => {
                    if (confirm.isConfirmed) {
                      this.selecttab.emit(14);
                    } else {
                      this.forceFinishCodebtorFlow()
                    }
                  });
                }
                this.validateSIRC(dataproductos);
              } else {
                this.alertService.confirmationHMTL(
                  `<strong>Nota:</strong>`,
                  `<span>El codeudor ingresado es codeudor de otro cliente. Puede agregar otro codeudor a continuación.</span><br>`,
                  'Continuar'
                ).then(confirm => {
                  if (confirm.isConfirmed) {
                    this.clienteserviceParam.datosPrecalificacionCodeudor = {};
                    this.clienteserviceParam.commonCredits = [];
                    this.showDpiAlert();
                  } else {
                    this.clienteserviceParam.commonCredits = [];
                    this.clienteserviceParam.datosPrecalificacionCodeudor = {};
                    this.clienteserviceParam.rejectCoDebtorFlow().then(() => {
                      this.selecttab.emit(11);
                    });
                  }
                });
              }
            }
          }).catch(error => {
            this.stopTask(this.TASK_PRODUCTOS);
            if (error.error!=null&&error.error.codigoError == "88") {
              this.showNotification(
                "Aviso",
                error.error.mensajeTecnicoAPI
              );
            } else {
              this.showNotification('Aviso', 'En estos momentos no se ha podido realizar la consulta de productos. inténtelo de nuevo en unos minutos');
            }
            this.selecttab.emit(0); 
          });
        } else {
          this.validatePatronoProducto()
        }

      }
    });

  }
  forceFinishCodebtorFlow() {
    if(this.clienteserviceParam.datosPrecalificacion.segmento!='PV'){
      this.startTask(this.TASK_CODEUDOR);
      this.clienteserviceParam.commonCredits = [];
      this.clienteserviceParam.datosPrecalificacionCodeudor = {};
      this.clienteserviceParam.rejectCoDebtorFlow().then(() => {
        this.stopTask(this.TASK_CODEUDOR);
        this.selecttab.emit(11);
      });
    } else {
      this.clienteserviceParam.rejectCoDebtorFlow()
      this.startTask(this.TASK_OFERTA);
        this.clienteserviceParam
        .solicitarOferta()
        .then((result) => {
          this.stopTask(this.TASK_OFERTA);
          this.clienteserviceParam.datosCliente.needCoDebtor = false;
          if (result == "SD") {
            this.showNotification(
              "No se han obtenido ofertas",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          } else if (result == "A") {
            if (this.clienteserviceParam.ofertasComerciales.ofertaComercial.length == 2 && this.clienteserviceParam.ofertasComerciales.ofertaComercial[0].bienestarMixAndMatchFlg==1) {
              this.clienteserviceParam.ofertaseleccionada = 0
              this.clienteserviceParam.ofertamym=0
              this.selecttab.emit(13)
            } else {
              this.selecttab.emit(12);
            }
          } else {
            this.showNotification(
              "Ha ocurrido un error",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          }
        })
        .catch((error) => {
          this.stopTask(this.TASK_OFERTA);
          if (error.codigoError && error.codigoError == "1003") {
            this.showNotification(
              "Aviso",
              error.mensajeTecnicoAPI
            );
          }
          else if (error.codigoError!="0") {
            this.showNotification(
              "Aviso",
              'Ha ocurrido un error, intentelo más tarde. Código de error: '+error.codigoError
            );
          }
          else if (error == "errorguardado") {
            this.showNotification(
              "Ha ocurrido un error",
              "No se ha podido guardar la precalificación."
            );
          } else{
            this.showNotification(
              "Alerta",
              "No se ha podido establecer conexión con el servidor, intentelo de nuevo."
            );
          }
        });

    }
  }
  setData() {
    this.getEdadCliente();
    if (this.clientData.cliente.nit === '') {
      this.isNitRequest = true;
    }
    if (!this.movilPrincipal && this.clientData.telefonos.length > 0) {
      if (this.clientData.telefonos.find(i => i.esTelefonoPrincipal === 'S') != null) {
        if (this.validarTelefono(this.clientData.telefonos.find(
          i => i.esTelefonoPrincipal === 'S').numeroTelefonoRegistrado) !== 'invalido') {
          let tipoprincipalselected = '';
          if (this.validarTelefono(this.clientData.telefonos.find(
            i => i.esTelefonoPrincipal === 'S').numeroTelefonoRegistrado) === 'cel') {
            this.movilPrincipal = this.clientData.telefonos.find(
              i => i.esTelefonoPrincipal === 'S').numeroTelefonoRegistrado;
            tipoprincipalselected = 'cel';
          } else {
            this.telefonoPrincipal = this.clientData.telefonos.find(
              i => i.esTelefonoPrincipal === 'S').numeroTelefonoRegistrado;
            tipoprincipalselected = 'tel';
          }
          this.clientData.telefonos.forEach(element => {
            if (tipoprincipalselected === 'cel') {
              if (this.validarTelefono(element.numeroTelefonoRegistrado) === 'tel') {
                this.telefonoPrincipal = element.numeroTelefonoRegistrado;
              }
            } else {
              if (this.validarTelefono(element.numeroTelefonoRegistrado) === 'cel') {
                this.movilPrincipal = element.numeroTelefonoRegistrado;
              }
            }
          });
        }
      }
    }
    this.direccionPrincipal = this.clientData.direcciones.find(i => i.esDireccionPrincipal === 'S');
    this.edadCliente = this.clienteserviceParam.getEdadCliente();
    this.estadoCivil = this.clientData.cliente.estadoCivil === 'S'
      ? 'Solter'
      : this.clientData.cliente.estadoCivil === 'C'
        ? 'Casad' : this.clientData.cliente.estadoCivil === 'V'
          ? 'Viud' : this.clientData.cliente.estadoCivil === 'D'
            ? 'Divorciad' : '';
    this.estadoCivil = this.estadoCivil + (this.clientData.cliente.genero === 'M' ? 'o' : 'a');

    switch (this.clientData.cliente.tipoVivienda) {
      case '1': {
        this.tipoVivienda = 'ALQUILADA';
        break;
      }
      case '2': {
        this.tipoVivienda = 'PROPIA';
        break;
      }
      case '3': {
        this.tipoVivienda = 'FAMILIAR';
        break;
      }
      case '4': {
        this.tipoVivienda = 'PARCIALMENTE PAGADA';
        break;
      }
      case '5': {
        this.tipoVivienda = 'EN USUFRUCTO';
        break;
      }
      case '6': {
        this.tipoVivienda = 'DEPURA. BENEFIC.';
        break;
      }
      default: {
        this.tipoVivienda = '';
        break;
      }
    }
  }
  validarTelefono(telefono) {
    let result = 'invalido';
    const re = new RegExp('^[2,6,7,8][0-9]{7}$');
    const recel = new RegExp('^[3-5][0-9]{7}$');

    if (re.test(telefono)) {
      result = 'tel';
    }

    if (recel.test(telefono)) {
      result = 'cel';
    }

    return result;
  }
  showNotification(title, message) {
    swal.fire({
      title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {

    });
  }

  satNitValidate() {
    this.startTask(this.TASK_NIT);
    this.clienteserviceParam.consultaClienteSAT(this.clientData.cliente.nit).then(datos => {
      this.stopTask(this.TASK_NIT);
      if (datos.error && datos.error.codigoError === '0') {
        let dpi = datos.dpi;
        let name = datos.nombre;

        if (dpi != null || name != null) {
          dpi = dpi.trim();
          name = name.split(',');
          const firstName = name[3];
          const lastName = name[0];
          if (dpi) {
            if (dpi.length !== 13) {
              this.showNotification('Alerta', 'El nit ingresado no es correcto');
              return;
            }

            if (this.clientData.cliente.dpi !== dpi) {
              this.showNotification('Alerta', 'El nit ingresado no pertenece al cliente.');
              return;
            }
          } else {
            if (firstName.trim() !== this.clientData.cliente.primerNombre.trim()
              && lastName.trim() !== this.clientData.cliente.primerApellido.trim()) {
              this.showNotification('Alerta', 'El nit ingresado no pertenece al cliente.');
              return;
            }
          }
        } else {
          this.showNotification('Alerta', 'El nit ingresado no es correcto');
          return;
        }

        this.showSegmentoSelect();

      } else {
        if (datos.error.codigoError === '60') {
          this.showNotification('Alerta', 'Ha ocurrido un error, Compruebe que el NIT este correcto.');
          return;
        } else {
          this.showNotification('Alerta', 'Ha ocurrido un error al solicitar información.');
          return;
        }
      }
    }).catch(() => {
      this.stopTask(this.TASK_NIT);
      this.showNotification('Alerta', 'Ha ocurrido un error al solicitar información.');
    });
  }
  validateSIRC(data: any): void {
    const internal = data.internoBantrab;
    const external = data.sircRuta12;
    // case 1
    if (external === null
      && (internal.creditos !== null
        || internal.tarjetas !== null)) {
      let credits = internal.creditos !== null ? internal.creditos : [];
      let cards = internal.tarjetas !== null ? internal.tarjetas : [];
      let differenceMonth = 0;
      const currentDate = moment();

      if (credits.length > 1) {
        credits = credits.reverse();
      }

      if (cards.length > 1) {
        cards = cards.reverse();
      }

      const lastCredit = credits.length > 0 ? credits[0] : null;
      const lastCard = cards.length > 0 ? cards[0] : null;

      if (lastCredit && lastCard) {
        const cardDate = moment(lastCard.fechaConsesion, 'DD/MM/YYYY');
        const diffDaysCard = currentDate.diff(cardDate, 'days');
        const creditDate = moment(lastCredit.fConsecion, 'DD/MM/YYYY');
        const diffDaysCredit = currentDate.diff(creditDate, 'days');
        if (diffDaysCard < diffDaysCredit ) {
          differenceMonth = currentDate.diff(cardDate, 'months');
        } else {
          differenceMonth = currentDate.diff(creditDate, 'months');
        }
      } else if (lastCredit && !lastCard) {
        const creditDate = moment(lastCredit.fConsecion, 'DD/MM/YYYY');
        differenceMonth = currentDate.diff(creditDate, 'months');
      } else if (lastCard && !lastCredit) {
        const cardDate = moment(lastCard.fechaConsesion, 'DD/MM/YYYY');
        differenceMonth = currentDate.diff(cardDate, 'months');
      } else {
        this.showNotification('Nota', 'Ha ocurrido un error, intente de nuevo en unos minutos');
        this.selecttab.emit(0);
        return;
      }

      if (differenceMonth > 1) {
        this.showNotification('Nota',
          'Hubo una inconsistencia en la respuesta de la SIRC, no se puede finalizar el proceso, '
          + 'favor avocarse con su Centro de Procesamiento');
        this.selecttab.emit(0);
        return;
      } else {
        this.validatePatronoProducto()
      }
    } else {
      this.validatePatronoProducto()
    }
  }

  showDpiAlert() {
    const dpi = '';
    swal.fire({
      title: 'Ingrese el DPI del codeudor',
      input: 'text',
      inputLabel: 'DPI',
      inputValue: dpi,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      showCloseButton: false,
      allowOutsideClick: false,
      buttonsStyling: false,
      heightAuto: false,
      inputValidator: result => !result && 'Por favor ingrese un número de DPI.'
        || result.length !== 13 && 'El número de DPI no es válido, favor verifique.'
        || result === this.clienteserviceParam.datosCliente.cliente.dpi && 'El número de DPI ingresado no puede ser igual al de deudor',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      confirmButtonText: 'Continuar',
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.clienteserviceParam.commonCredits = [];
        this.clienteserviceParam.datosPrecalificacionCodeudor = {};
        // El loader lo abre y lo cierra el padre dentro de setDataCliente(), que corre
        // de forma síncrona con este emit; iniciarlo aquí dejaría una tarea huérfana.
        this.setDataCliente.emit({
          dpi: result.value,
          flowType: 'CODEBTOR',
        });
      }
    });
  }
  setCodDepto(){
    let codDepto=this.departamentos.find(i=>i.nombreDepartamento==this.clientData.cliente.departamento).codigoDepartamento
    this.municipiosAux=this.municipios.filter(i=>i.codigoDepto==codDepto)
  }
  validatePatronoProducto() {
    let enviarOTP = true;
    if (this.clienteserviceParam.datosPrecalificacion.segmento == "E" && this.clienteserviceParam.tipoPrecalificacion == 'tarjeta_credito') {     
      if (this.clientData.datosIndice == null || this.clientData.datosIndice.clienteDatosIndice.length == 0) {
        this.showNotification('Alerta','El cliente no posee un patrono permitido para precalificar por segmento Remesa.');
        enviarOTP = false;
      }
      else if (this.clientData.datosIndice.clienteDatosIndice.length == 1 && Constants.ALLOWED_PATRONS_TC_PED.includes(this.clientData.datosIndice.clienteDatosIndice[0].numeroPatrono)) {
        enviarOTP = true;
      }
      else if (this.clientData.datosIndice.clienteDatosIndice.length == 2) {
        if (Constants.ALLOWED_PATRONS_TC_PED.includes(this.clientData.datosIndice.clienteDatosIndice[0].numeroPatrono)&&Constants.ALLOWED_PATRONS_TC_PED.includes(this.clientData.datosIndice.clienteDatosIndice[1].numeroPatrono)) {
          enviarOTP = true;
        }
        else if (!Constants.ALLOWED_PATRONS_TC_PED.includes(this.clientData.datosIndice.clienteDatosIndice[0].numeroPatrono)) {
          this.clientData.datosIndice.datosIndiceclienteDatosIndice.shift()
          this.showNotification('Alerta', 'El cliente posee mas de un patrono, sin embargo solo uno de los patronos es permitido para precalificar por segmento Remesa.')
          enviarOTP = true;
        } else {
          this.clientData.datosIndice.clienteDatosIndice.pop()
          this.showNotification('Alerta', 'El cliente posee mas de un patrono, sin embargo solo uno de los patronos es permitido para precalificar por segmento Remesa.')
          enviarOTP = true;
        }
      } else{
        enviarOTP = false;
        this.showNotification('Alerta','El cliente no posee un patrono permitido para precalificar por segmento Remesa.') 
      }
    } 
    
    if (this.clienteserviceParam.rolABFlag) {
      if (enviarOTP) {
        const producto: 'TC' | 'PRC' = this.clienteserviceParam.tipoPrecalificacion === 'tarjeta_credito' ? 'TC' : 'PRC';
        if(this.authService.isBankAgent()){
          this.startTask(this.TASK_OTP);
          this.clienteserviceParam.solicitudOTP(this.movilPrincipal,this.clienteserviceParam.datosCliente.cliente.dpi,producto ).then(result=>{
            this.stopTask(this.TASK_OTP);
            const dialogRef = this.dialog.open(ModalOtpComponent, {
              width: "30vw",
              height: "auto",
              data: {
                cel: this.movilPrincipal,
                dpi:this.clienteserviceParam.datosCliente.cliente.dpi,
                producto
              }
            });
            dialogRef.afterClosed().subscribe((result) => {
              if(result.result){
                this.selecttab.emit(15);
              }else{
                this.showNotification('Token invalido','El token ingresado no es valido, verificación fallida.')
              }
            })
          }).catch(error=>{
            this.stopTask(this.TASK_OTP);
            this.showNotification('Ha ocurrido un error','No se ha logrado enviar token de verificación de telefono, intentelo nuevamente.')
          })
        }else{
          this.selecttab.emit(15);
        }
      }
    }else{
      this.selecttab.emit(15)
    }
  }
}
